import Request from './../request';
import { IPermissionResourceShort } from '../../props/roles';

// import interfaces

const PermissionServices = {
  retrieve: async (): Promise<IPermissionResourceShort[]> => {
    try {
      const results = await Request.get(`/api/permissions`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (data: FormData): Promise<IPermissionResourceShort[]> => {
    try {
      const results = await Request.post(`/api/permissions`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  update: async (data: FormData, id: string): Promise<IPermissionResourceShort[]> => {
    try {
      const results = await Request.post(`/api/permissions/${id}?_method=PUT`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  delete: async (id: string): Promise<IPermissionResourceShort[]> => {
    try {
      const results = await Request.delete(`/api/permissions/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
};

export default PermissionServices;
